export enum LocationError {
  UNKNOWN = 1,
  DISALLOWED = 2,
}

export interface LocationCoords {
  lat?: number
  lng?: number
  error?: LocationError
}

export interface UpdateLocationPayload {
  lat: number
  lng: number
}

export interface LocationState {
  lat: number | null
  lng: number | null
  allowed: boolean | null
  loading: boolean
}

export enum LOCATION_MUTATIONS {
  START_UPDATING_LOCATION = 'startUpdatingLocation',
  STOP_UPDATING_LOCATION = 'stopUpdatingLocation',
  UPDATE_LOCATION = 'updateLocation',
  DISALLOW_LOCATION = 'disallowLocation',
}

export enum LOCATION_ACTIONS {
  UPDATE_LOCATION = 'updateLocation',
}

export enum LOCATION_GETTERS {
  CURRENT_LOCATION = 'currentLocation',
  LOADING = 'loading',
}
